import React, { useState } from 'react'

import {
  Spinner,
  Icon,
  InfoOutlined,
  InfoFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'
import Tooltip from 'Pods/Shared/Tooltip'

import { useReferralLink } from '../../Hooks/useReferralLink'
import { useReferrals } from '../../Hooks/useReferrals'
import EmptyMessage from '../EmptyMessage'

const columnsConfig = {
  id: { visible: false },
  username: { title: 'Username', position: 1 },
  email: { title: 'Email', position: 2 },
  createdAt: { title: 'Registered at', position: 3 },
  validUntil: { title: 'Valid Until', position: 4 },
  status: { title: 'Status', position: 5 },
}

function Referrals() {
  const { referrals, isLoading } = useReferrals()
  const { referralLink } = useReferralLink()
  const [copied, setCopied] = useState(false)

  const referralData = referrals.map((referral) => ({
    username: referral.username,
    email: referral.email,
    createdAt: referral.createdAt,
    validUntil: referral.validUntil,
    status: referral.status,
  }))

  const copyToClipboard = (event) => {
    event.preventDefault()
    navigator.clipboard.writeText(referralLink.designerPage)
    setCopied(true)
  }

  return (
    <div className="cgt-mb-10">
      {isLoading ? (
        <div className="spinner-container">
          <Spinner />
        </div>
      ) : (
        <div>
          <div className="data-tooltip-container" onClick={copyToClipboard}>
            Your referral link →{' '}
            <a href={referralLink.designerPage}> {referralLink.designerPage}</a>
            <Tooltip
              content={[
                'You can share links to any page on CGTrader — including your models or the homepage — ',
                'just make sure the URL includes ?referral_id=your_ID. For example: ',
                referralLink.homepage,
              ].join('')}
              id="referral-link"
            >
              <Icon
                svgComponent={InfoOutlined}
                color="dark"
                size="small"
                className="data-tooltip-container__icon"
              />
            </Tooltip>
            <button
              className={`btn btn-sm btn-${copied ? 'default' : 'primary'}`}
            >
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>
          <div className="cgt-mt-10 referral-program-info">
            <Icon
              svgComponent={InfoFilled}
              color="dark"
              size="small"
              className="data-tooltip-container__icon"
            />
            <span>
              Learn more about our referral program{' '}
              <a href="https://help.cgtrader.com/hc/en-us/articles/35430275704465-How-Referrals-Work-on-CGTrader">
                here
              </a>
            </span>
          </div>

          <LegacyDataTable
            data={referralData}
            columnsConfig={columnsConfig}
            EmptyMessage={(
              <EmptyMessage
                title="Oops, no Referrals!"
                description="You don't have any referrals yet."
              />
            )}
          />
        </div>
      )}
    </div>
  )
}

export default Referrals
